import React from 'react';
import { Carousel, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './StarterPromptsCarousel.css';

const StarterPromptsCarousel = ({ prompts, onPromptClick }) => {
    const handlePromptClick = (prompt) => {
        if (onPromptClick) {
            onPromptClick(prompt);
        }
        // open chat w/ prefilled question
    };

    return (
        <div
            className="starter-prompts-carousel"
            role="region"
            aria-labelledby="starter-prompts-heading"
        >
            <Carousel
                indicators={true}
                controls={true}
                interval={null}
                className="prompts-carousel"
                prevLabel="Previous prompt"
                nextLabel="Next prompt"
            >
                {prompts.map((prompt, index) => (
                    <Carousel.Item key={index}>
                        <div className="prompt-slide">
                            <h3 className="prompt-question mb-4">{prompt}</h3>
                            <Button
                                className="prompt-cta-btn"
                                onClick={() => handlePromptClick(prompt)}
                                aria-label={`Chat with Bili: ${prompt}`}
                            >
                                Chat with Bili
                            </Button>
                        </div>
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
};

StarterPromptsCarousel.propTypes = {
    prompts: PropTypes.arrayOf(PropTypes.string).isRequired,
    onPromptClick: PropTypes.func,
};

export default StarterPromptsCarousel;
